module.exports = __webpack_public_path__ + "static/media/05-10.e0ee504e.png";